import React from 'react'
import PropTypes from 'prop-types'

import i18n from './../../../config/i18n'

import { SectionLink } from '../../../entities/Page'

import { LinksList } from './LinksList'
import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import { SectionBlock } from './../SectionBlock/SectionBlock'

import './SectionLinks.css'
import { Hide } from '../Hide'

const SectionLinks = ({ title, dark = false, links = [] }) => {
    title = title || i18n.t('general.featured-title')
    return (
        <Hide ifEmpty={links}>
            <SectionBlock withContainer dark={dark}>
                <TopSectionTitle title={title} underlined dark={!dark} centered />
                <LinksList links={links} dark={dark} />
            </SectionBlock>
        </Hide>
    )
}

SectionLinks.propTypes = {
    title: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.instanceOf(SectionLink)),
    dark: PropTypes.bool
}

export { SectionLinks }
